export default __webpack_public_path__ + "static/media/as.9eff3c0d.svg";